import styled from "styled-components";

export const AccordionSection = styled.div`
  padding-top: 0;
`;

AccordionSection.displayName = "AccordionSection";
